import { type ReactNode, useState } from "react";
import { Icon } from "../Icon";
import { MetaSep } from "../MetaSeparator";
import { Text } from "../Text";
import { DefaultIcon, HoverIcon, ToggleIconContainer } from "../ToggleIcon";
import { WavyLine } from "../WavyLine";
import {
  CollapsibleHeader,
  CollapsibleHeaderInner,
  ExpandedContent,
  ExpandedContentHover,
  ExpandedTimestamp,
  ExpandInner,
  ExpandWrapper,
} from "./Expand";
import { TypewriterText } from "./TypewriterText";

export function RecapPendingRow() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 4,
        height: 28,
        padding: "6px 10px 6px 8px",
      }}
    >
      <WavyLine size={12} color="var(--text-secondary)" opacity={1} />
      <Text variant="text-small" color="var(--text-secondary)">
        Generating recap…
      </Text>
    </div>
  );
}

export function RecapEntry({
  text,
  createdAt,
  trailing,
}: {
  text: string;
  createdAt: number;
  trailing?: ReactNode;
}) {
  const [expanded, setExpanded] = useState(false);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <CollapsibleHeader onPress={() => setExpanded((prev) => !prev)}>
          <CollapsibleHeaderInner>
            <ToggleIconContainer aria-hidden>
              <DefaultIcon>
                <Icon name="bookmark" size={12} color="var(--text-secondary)" />
              </DefaultIcon>
              <HoverIcon>
                <Icon
                  name={expanded ? "minus" : "plus"}
                  size={12}
                  color="var(--text-secondary)"
                />
              </HoverIcon>
            </ToggleIconContainer>
            <Text variant="text-small" color="var(--text-secondary)">
              Recap
            </Text>
          </CollapsibleHeaderInner>
        </CollapsibleHeader>
        {trailing && (
          <>
            <Text variant="text-small" color="var(--text-secondary)">
              <MetaSep />
            </Text>
            {trailing}
          </>
        )}
      </div>
      <ExpandWrapper data-expanded={expanded}>
        <ExpandInner data-expanded={expanded}>
          <ExpandedContentHover>
            <ExpandedContent>
              <TypewriterText
                text={text}
                streaming={false}
                plain
                variant="text-small"
                color="var(--text-secondary)"
              />
            </ExpandedContent>
            <ExpandedTimestamp createdAt={createdAt} />
          </ExpandedContentHover>
        </ExpandInner>
      </ExpandWrapper>
    </div>
  );
}
